<!-- Copyright 2019, Nathan Lecompte -->

<template>
    <label @keydown.enter="$emit('change', $event.target.checked=!checked);onToggle()" :class="['toggle', { 'toggleChecked': checked }]" :for="id" :title="title" :aria-label="title" tabindex="0">
        <!-- Toggle -->
        <div>
            <input 
                :checked="checked"
                @change="$emit('change', $event.target.checked);onToggle()"
                :id="id" 
                name="toggle" 
                type="checkbox">
            <!-- Toggle knob -->
            <span></span>
        </div>
    </label>
</template>

<script>
export default {
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        // Id of current toggle
        id: {
            type: String,
            required: true
        },
        // Flag if toggle is checked
        checked: {
            type: Boolean,
            required: true
        },
        // Title / Aria-label for toggle (accessibility)
        title: {
            type: String,
            required: true
        },
        // Function on toggle changed
        onToggle: {
            type: Function,
            required: true
        }
    }
}
</script>

<style>
/* Toggle component */
.toggle {
	position: relative;
	display: inline-block;
	padding: 10px;
	margin: -5px -10px;
	cursor: pointer;
	outline: none;
	-webkit-tap-highlight-color: transparent
}
.toggle div {
	background: rgba(var(--primaryColor), .05);
	border: 1px solid rgba(var(--primaryColor), .025);
	border-radius: 20px;
	width: 40px;
	margin: 2px 2px 5px;
	transition: var(--animationSpeed) ease
}
.toggleChecked div {
	background: rgb(var(--accentColor))
}
.toggle input {
	display: none
}
.toggle span {
	position: relative;
	display: block;
	background: rgb(var(--backgroundColor));
	box-shadow: 0 0 0 1.2px rgba(var(--primaryColor), .125),
        0 1px 2px rgba(var(--primaryColor), .125);
	border-radius: 20px;
	width: 18px;
	height: 18px;
	left: 0;
	transform: scale(1.2);
	transition: calc(var(--animationSpeed)/2) ease
}
.toggle:active span,
.toggle:focus span {
	box-shadow: 0 0 0 1.2px rgba(var(--accentColor), .2), 
        0 1px 2px rgba(var(--accentColor), .2),
		inset 0 0 0 22px rgba(var(--accentColor), .05)
}
.toggle:active span {
	width: 22px
}
.toggle input:checked + span {
	left: 22px
}
.toggle:active input:checked + span {
	left: 18px
}
</style>